import { Navigate, Outlet } from 'react-router-dom'
import { useStateValue } from '../providers'

const hasRole = (user, allowedRoles) => {
  if (!user?.roles || !allowedRoles) return false
  return user.roles.some((role) => allowedRoles.includes(role.slug))
}

export const ProtectedRoute = ({ flag, protect, roles }) => {
  const [{ session }] = useStateValue()

  // Check role-based access
  if (roles && !hasRole(session?.user, roles)) {
    return <Navigate to="/" replace />
  }

  // Check permission-based access
  if (protect && !session.ability?.can(protect.action, protect.subject)) {
    return <Navigate to="/" replace />
  }

  return <Outlet />
}
